import React from 'react';
import { leadtubWebsite } from './CONSTANTS';


function Copyright(props) {
    return (
      <a variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <a color="inherit" href={leadtubWebsite} target="_blank" rel="noopener noreferrer">
         {leadtubWebsite}
        </a>{' '}
        {new Date().getFullYear()}
        {'.'}
      </a>
    );
  }

export default Copyright;
